import { createContext, type ReactNode, useContext } from "react";

interface FormEditorLayoutContextValue {
	isReadOnly: boolean;
}

const FormEditorLayoutContext = createContext<FormEditorLayoutContextValue>({
	isReadOnly: false,
});

export interface FormEditorLayoutProviderProps {
	isReadOnly?: boolean;
	children: ReactNode;
}

/**
 * Supplies layout-level flags (e.g. read-only) to nested form editor routes
 * (`/full/form/rules`, drawer `form/rules`) without duplicating permission logic.
 */
export function FormEditorLayoutProvider({
	isReadOnly = false,
	children,
}: FormEditorLayoutProviderProps) {
	return (
		<FormEditorLayoutContext.Provider value={{ isReadOnly }}>
			{children}
		</FormEditorLayoutContext.Provider>
	);
}

/**
 * Returns read-only state from the nearest {@link FormEditorLayoutProvider}.
 */
export function useFormEditorLayoutContext(): FormEditorLayoutContextValue {
	return useContext(FormEditorLayoutContext);
}
